import { useCallback as e } from "react";
import { useTranslation as t } from "react-i18next";
import { CouponIneligibleReason as n } from "@maat/api-booking/types";
//#region src/enums/useTrCouponIneligibleReason.ts
var r = () => {
	let { t: r } = t("booking");
	return e((e) => {
		if (e) switch (e) {
			case n.CurrencyMismatch: return r("checkout.coupon.currencyMismatch");
			default: return;
		}
	}, [r]);
};
//#endregion
export { r as useTrCouponIneligibleReason };
